import React, { useState, useEffect } from "react"
import ModalTiny from "react-bootstrap/Modal"

import ContactForm from "../forms/contact-us-form"


const ContactModal = (props,{children}) => {

    const [modalAskformOpen,setAskformOpen] = React.useState(false);
    const openAskformModal = () => {
      setAskformOpen(true);
    }
    const closeAskformModal = () => {
      setAskformOpen(false);
    }

    return (
        <>
            <a className={props.class} href="javascript:void(0);" onClick={openAskformModal}>{props.children}</a>
        
            <ModalTiny show={modalAskformOpen} onHide={closeAskformModal} className="book-a-viewing-modal modal-main-form">
                <ModalTiny.Header closeButton className="contact-close-btn">
                    <ModalTiny.Title className="w-100"><h2 className="text-center mb-0">{props.title ? props.title : 'Contact Form'}</h2>
                    <p>Fields marked with an '*' must be completed.</p>
                    </ModalTiny.Title>
                </ModalTiny.Header>
                <ModalTiny.Body className="event-section people-details-form-modal"><ContactForm /></ModalTiny.Body>
            </ModalTiny>
        </>
    )
}

export default ContactModal
